import React from 'react'
import Loader from 'react-loader-spinner'
import './button.scss'
interface IPropsButton {
  children: React.ReactNode
  title: string
  loading: boolean
  className: string
  onClick?: (() => void) | null
  type?: 'button' | 'submit' | 'reset' | undefined
  disabled: boolean
  tag?: string | null
  colorLoading?: string
}
const Button = ({
  children,
  title = '',
  loading = false,
  className = '',
  onClick,
  type,
  disabled = false,
  tag = null,
  colorLoading = '#ffffff',
}: IPropsButton) => {
  return (
    <button
      className={
        'f-button ' +
        className +
        ' ' +
        (loading ? 'loading' : '') +
        (disabled ? ' --disabled ' : '')
      }
      onClick={!disabled && onClick ? onClick : undefined}
      title={title}
      role="button"
      data-tag={tag}
      type={type ? type : 'button'}
      disabled={disabled}
    >
      <div className="f-button__content">
        {loading ? (
          <Loader type="Oval" color={colorLoading} height={22} width={30} />
        ) : (
          children
        )}
      </div>
    </button>
  )
}

export default Button
